module.exports = __webpack_public_path__ + "img/14-1_04.c258b943.jpg";